export default class PetsHiringInsured {
  chipNumber: string | null
  petName: string
  petBirthDate: Date | string | undefined
  petTypeCode: number
  breedCode: number
  riskNumber: number
  hasAccidentInsurance: boolean | null | undefined
  accidentPolicy: string
  accidentCompany: string | null
  hasRcInsurance: boolean | null | undefined
  rcPolicy: string | null
  rcCompany: string | null
  constructor(data: any = {}) {
    this.chipNumber = data.chipNumber
    this.petName = data.petName
    this.petBirthDate = data.petBirthDate
    this.petTypeCode = data.petTypeCode
    this.breedCode = data.breedCode
    this.riskNumber = data.riskNumber
    this.hasAccidentInsurance = data.hasAccidentInsurance
    this.accidentPolicy = data.accidentPolicy
    this.accidentCompany = data.accidentCompany
    this.hasRcInsurance = data.hasRcInsurance
    this.rcPolicy = data.rcPolicy
    this.rcCompany = data.rcCompany
  }

  updateAttributes(newAttributes: any) {
    Object.assign(this, newAttributes)
  }
}
